<template>
    <b-card no-body v-if="details">
        <div class="card-header">
            <h4 class="mb-0 pb-0">Vukuat Onay Detayları</h4> 
        </div>
        <hr class="m-0 p-0"></hr>
        <div class="card-body row p-1">
            <b-card title="Personel ve Vukuat Detayları" class="m-0 p-0 col-md-4">
                <table class="table table-sm table-striped table-bordered mb-0">
                    <tbody>
                        <tr>
                            <th class="w-50">Personel Ad Soyad</th>
                            <td class="font-weight-bold">{{ details.EmployeeFullName || ""}}</td>
                        </tr>
                        <tr>
                            <th>Personel T.C. Kimlik No</th>
                            <td>{{ details.EmployeeIdentityNumber || ""}}</td>
                        </tr>
                        <tr>
                            <th>Personel Sicil Numarası</th>
                            <td>{{ details.EmployeeRegistrationCode || ""}}</td>
                        </tr>
                        <tr>
                            <th>Vukuat Referans No</th>
                            <td>{{ details.RefNumber}}</td>
                        </tr>
                    </tbody>
                </table>
            </b-card>

            <b-card title="Değişiklik Detayları" class="m-0 p-0 col-md-8">
                <table class="table table-sm table-striped table-bordered mb-0">
                    <thead>
                        <th class="text-primary">Değişiklik İstenen Alan</th>
                        <th class="text-danger">Eski Değer</th>
                        <th class="text-success">Yeni Değer</th>
                    </thead>
                    <tbody>
                        <tr v-for="d in details.ChangeRequests" :key="d.Key">
                            <th class="w-50">{{ d.Key }}</th>
                            <td class="font-weight-bold">{{ d.OldValue }}</td>
                            <td class="font-weight-bold">{{ d.NewValue }}</td>
                        </tr>
                         <tr class="bg-primary">
                            <th class="w-50 text-warning bg-primary text-right">İŞLEM AÇIKLAMASI</th>
                            <td colspan="2" class="font-weight-bold text-warning">{{details.ChangeDescription || "-"}}</td>
                        </tr>
                    </tbody>
                </table>
            </b-card>
        </div>
         <div class="card-body row p-1">
            <b-card title="Finansal Özet" class="m-0 p-0 col-md-6">
                <table class="table table-sm table-striped table-bordered mb-0">
                    <tbody>
                        <tr>
                            <th class="w-50">Toplam Vukuat Tutarı</th>
                            <td class="font-weight-bold">{{ details.TotalAmount | currency }}</td>
                        </tr>
                        <tr>
                            <th>Personele Yansıtılan Tutar</th>
                            <td>{{ details.EmployeeAmount | currency }}</td>
                        </tr>
                        <tr>
                            <th>Firmanın Karşıladığı Tutar</th>
                            <td>{{ details.CompanyAmount | currency }}</td>
                        </tr>
                        <tr>
                            <th>Taksit Sayısı</th>
                            <td>{{ details.InstallmentCount }}</td>
                        </tr>
                    </tbody>
                </table>
            </b-card>

            <b-card title="Personel Vukuat Analizi" class="m-0 p-0 col-md-6">
                <table class="table table-sm table-striped table-bordered mb-0">
                    <tbody>
                        <tr>
                            <th class="w-50">Personel Kıdemi (Yıl)</th>
                            <td>{{ details.EmployeeWorkingYears }}</td>
                        </tr>
                        <tr>
                            <th>Personelin Kaçıncı Vukuatı</th>
                            <td>{{ details.IncidentIndex }}</td>
                        </tr>
                        <tr>
                            <th>Personelin Toplam Vukuat Tutarı</th>
                            <td>{{ details.TotalAllIncidentsAmount | currency }}</td>
                        </tr>
                        <tr>
                            <th>Firma Karşılama Oranı</th>
                            <td>% {{ details.Percent ? details.Percent.toFixed(2) : "0.00" }}</td>
                        </tr>
                    </tbody>
                </table>
            </b-card>
        </div>
        <div class="px-2">
            <div class="description-box mt-1 mb-2">
                <h6 class="font-weight-bold mb-50">Açıklama</h6>
                <p v-if="details.Description" class="mb-0 pl-50">
                    {{ details.Description }}
                </p>
                <p v-else class="text-muted font-italic pl-50 mb-0">Açıklama eklenmemiştir.</p>
            </div>
            <div class="description-box mt-1 mb-2">
                <h6 class="font-weight-bold mb-50">Talimatı Veren Personel</h6>
                <p v-if="details.OrderedByEmployeeFullName" class="mb-0 pl-50">
                    {{ details.OrderedByEmployeeFullName }}
                </p>
            </div>
        </div>
        <div class="card-footer text-right">
            <b-button variant="danger" class="mr-2" v-on:click="$emit('reject')" :disabled="processing"> <b-spinner v-if="processing" small></b-spinner> Reddet </b-button>
            <b-button variant="success" v-on:click="$emit('approve')" :disabled="processing"> <b-spinner v-if="processing" small></b-spinner> Onayla </b-button>
        </div>
    </b-card>
    <b-card v-else>
        <b-alert show variant="warning">Detay bilgileri yüklenemedi.</b-alert>
    </b-card>
</template>

<script>
import { BAlert, BCard, BButton, BSpinner } from "bootstrap-vue";

export default {
    components: {
        BAlert,
        BCard,
        BButton,
        BSpinner,
    },
    props: {
        details: { type: Object, default: null },
        processing: { type: Boolean, default: false },
    },
    filters: {
        currency(value) {
            if (typeof value !== "number") {
                return value || "0,00 ₺";
            }
            return value.toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
        },
    },
};
</script>

<style>
th {
    background-color: #f3f2f7;
}
.description-box {
    border: 1px solid #ebe9f1;
    background-color: #f8f8f8;
    border-radius: 0.357rem;
    padding: 1rem;
    width: 100%;
}
</style>
